import classes from "./FormField.module.css";
import {Text, TextInput, TextInputProps} from "@mantine/core";

type FormFieldProps = { label: string; } & TextInputProps;

/**
 * Form field.
 * @author Kacper Faber
 * @since 0.1.8
 * @param props
 * @constructor
 */
function FormField(props: FormFieldProps) {
    return (
        <div className={classes.root}>
            <Text
                children={props.label}
                fw={500}
            />

            <TextInput
                placeholder=""
                w="50%"
                variant="filled"
                { ...props }
                label={undefined}
            />
        </div>
    );
}

export default FormField;